import {
  Space,
  Dropdown,
  Modal,
  Form,
  Input,
  message,
} from "antd";
import React, { useEffect, useState } from "react";
import {
  ExclamationCircleOutlined,
  MenuOutlined,
  EditOutlined,
  SolutionOutlined,
  FileTextOutlined,
  CreditCardOutlined,
  PieChartOutlined,
  ApartmentOutlined,
  TeamOutlined,
} from "@ant-design/icons";
import api from "@/utils/api";
import http from "@/utils/http";
import { CustomTable, CustomTableExtend } from "@/hocComponents";
import commonFn from "@/utils/commonFn";
import AddMenuModal from "./component/AddMenuModal";
import UpdateMenuModal from "./component/UpdateMenuModal";
export default function MainMenu() {
  const { TextArea } = Input;
  const [form] = Form.useForm();
  const [currentNode, setCurrentNode] = useState(null);
  const [addOpen, setAddOpen] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const [currentRecord, setCurrentRecord] = useState(null);
  const iconOptions = [
    {
      value: "CreditCardOutlined",
      label: "CreditCardOutlined",
      icon: <CreditCardOutlined />,
    },
    {
      value: "FileTextOutlined",
      label: "FileTextOutlined",
      icon: <FileTextOutlined />,
    },
    {
      value: "PieChartOutlined",
      label: "PieChartOutlined",
      icon: <PieChartOutlined />,
    },
    {
      value: "ApartmentOutlined",
      label: "ApartmentOutlined",
      icon: <ApartmentOutlined />,
    },
    { value: "TeamOutlined", label: "TeamOutlined", icon: <TeamOutlined /> },
  ];

  // 新增
  const handleNew = (node) => {
    setCurrentRecord({ type: "2" });
    setCurrentNode(node);
    setAddOpen(true);
  };

  const handleUpdate = (nodeData) => {
    setCurrentRecord(nodeData);
    setEditOpen(true);
  };
  // 删除
  const handleDelete = ({ menuId }) => {
    Modal.confirm({
      title: "Complete Request",
      icon: <ExclamationCircleOutlined />,
      content: <span>Are you sure to delete this menu?</span>,
      okText: "Sure",
      cancelText: "Cancel",
      onOk: async () => {
        const response = await http.get(api.getDelMenu, { params: { menuId } });
        if (response?.code == "1") {
          message.success("Successfully delete.");
          getTableListFn();
        } else {
          message.error(response.msg);
        }
      },
      onCancel() {
        // console.log("Cancel");
        form.resetFields();
      },
      style: {
        top: "40%",
      },
    });
  };

  const handleMenuClick = async (e, node) => {
    switch (e.key) {
      case "add":
        handleNew(node);
        break;
      case "update":
        handleUpdate(node);
        break;
      case "delete":
        handleDelete(node);
        break;
      default:
        break;
    }
  };

  // table
  const initTableHead = {
    role: undefined,
    module: undefined,
    firstName: undefined,
    dateTimeRequest: undefined,
  };
  const [tableHead, setTableHead] = useState(initTableHead);

  const tableFilterFn = (event, key, type = "Input") => {
    commonFn.tableFilterFn({ event, key, type, setTableHead, getTableListFn });
  };

  const initColumns = [
    {
      title: "Action",
      key: "action",
      dataIndex: "action",
      align: "center",
      width: 60,
      render: (text, record) =>
        (commonFn.btnAuthorityFlag("AddMenu") ||
          commonFn.btnAuthorityFlag("UpdateMenu") ||
          commonFn.btnAuthorityFlag("DeleteMenu")) && (
          <Dropdown
            menu={{
              items: [
                commonFn.btnAuthorityFlag("AddMenu") &&
                  record?.type !== 3 && {
                    key: "add",
                    icon: (
                      <EditOutlined
                        style={{ color: "#00c0ef", fontSize: "17px" }}
                      />
                    ),
                    label: <div>Add Menu</div>,
                  },
                commonFn.btnAuthorityFlag("UpdateMenu") && {
                  key: "update",
                  icon: (
                    <SolutionOutlined
                      style={{ color: "#00c0ef", fontSize: "17px" }}
                    />
                  ),
                  label: <div>Update Menu</div>,
                },
                commonFn.btnAuthorityFlag("DeleteMenu") && {
                  key: "delete",
                  icon: (
                    <SolutionOutlined
                      style={{ color: "#00c0ef", fontSize: "17px" }}
                    />
                  ),
                  label: <div>Delete Menu</div>,
                },
              ],
              onClick: (e) => handleMenuClick(e, record),
            }}
            trigger={["click"]}
          >
            <MenuOutlined
              style={{ cursor: "pointer", fontSize: "16px", color: "#0e78a9" }}
            />
          </Dropdown>
        ),
    },
    {
      title: "Name",
      dataIndex: "menuName",
      titleType: "Input",
      onChange: (e) => tableFilterFn(e, "menuName"),
    },
    {
      title: "Menu Url",
      dataIndex: "menuUrl",
      titleType: "",
      onChange: (e) => tableFilterFn(e, "menuUrl"),
    },
    {
      title: "Type",
      dataIndex: "type",
      titleType: "",
      render: (text) => {
        const typeMatch = {
          1: "Directory",
          2: "Menu",
          3: "Button",
        };
        return typeMatch[text || 1];
      },
    },
    {
      title: "Sort",
      dataIndex: "sort",
      titleType: "",
    },
    {
      title: "Remark",
      dataIndex: "remark",
      titleType: "",
    },
    {
      title: "Menu Icon",
      dataIndex: "menuIcon",
      titleType: "",
      render: (text) => iconOptions.find((item) => item.value === text)?.icon,
    },
  ];

  const [selectedItems, setSelectedItems] = useState([]);
  const [options, setOptions] = useState([]);
  const [columns, setColumns] = useState([]);
  const [refreshKey, setRefreshKey] = useState(0);
  const [tableList, setTableList] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 25,
    total: 0,
  });
  // 获取列表数据
  const getTableListFn = async (current, pageSize, tableHead = {}) => {
    setTableLoading(true);
    const params = {
      page: current || pagination.current,
      count: pageSize || pagination.pageSize,
      ...tableHead,
    };
    const response = await http.get(api.getMenu, { params });
    if (response?.code !== "1") {
      commonFn.modalFailedFn(response);
      setTableLoading(false);
      return;
    }
    setTableList(response.data || []);
    setPagination((prev) => ({
      ...prev,
      total: response.data.total || 0,
      current: params.page,
      pageSize: params.count,
    }));
    setTableLoading(false);
  };

  const handleTableChange = (pagination, filters, sorter) => {
    getTableListFn(pagination.current, pagination.pageSize, tableHead);
  };

  const initColunmsFn = () => {
    setTableHead(initTableHead);
    setColumns(initColumns);
    const transformedList = initColumns.map((item) => ({
      label: item.title,
      value: item.dataIndex,
    }));
    setOptions(transformedList);
    const transformedList2 = initColumns.map((item) => item.dataIndex);
    setSelectedItems(transformedList2);
  };

  useEffect(() => {
    initColunmsFn();
    getTableListFn(1, 25);
  }, [refreshKey]);

  return (
    <div>
      <CustomTableExtend
        columns={columns}
        setColumns={setColumns}
        initColumns={initColumns}
        refreshKey={refreshKey}
        setRefreshKey={setRefreshKey}
        noShowList={[!commonFn.btnAuthorityFlag("Download") && "download"]}
      >
        <div className="topLeft">
        {(commonFn.btnAuthorityFlag("New") && (
    <Space size="large">
    {commonFn.btnDocFn(
      { 
        btnFn: handleNew 
      },
      { 
        imageStyle: { filter: "brightness(0) invert(1)" } 
      }
    )}
  </Space>
)) || null}
        </div>
      </CustomTableExtend>
      <CustomTable
        refreshKey={refreshKey}
        tableLoading={tableLoading}
        expandable={{
          childrenColumnName: "childNode",
          indentSize: 30,
          rowExpandable: (record) => {
            console.log(record, "====reacord");
          },
        }}
        columns={columns}
        tableList={tableList}
        pagination={pagination}
        handleTableChange={handleTableChange}
        rowKey="menuId"
        tableCss="maintenanceTable"
      />

      <AddMenuModal
        open={addOpen}
        parentRecord={currentNode}
        currentRecord={currentRecord}
        onCancel={() => setAddOpen(false)}
        onSuccess={() => {
          setAddOpen(false);
          getTableListFn();
        }}
      />

      <UpdateMenuModal
        open={editOpen}
        record={currentRecord}
        onCancel={() => setEditOpen(false)}
        onSuccess={() => {
          setEditOpen(false);
          getTableListFn();
        }}
      />
    </div>
  );
}
